import React from "react";

import Layout from "../components/layout";
import SEO from "../components/seo";

const About = () => (
  <Layout Onabout={true}>
    <SEO title="About" />
    <h1 style={{ paddingTop: "30px" }}>About</h1>
    <h2>What?</h2>
    <p>
      Motivational Kittens West: random motivational posters made from kittens pictures, epic titles
      and Kanye West's quotes
    </p>
    <h2>Why?</h2>
    <p>
      It's puurrfect for Gatsby{" "}
      <a href="https://www.gatsbyjs.com/silly-site-challenge/" target="_blank" rel="noopener">
        Silly Site Challenge
      </a>
      .
    </p>
    <h2>How?</h2>
    <p>By using:</p>
    <p>
      <a href="https://www.gatsbyjs.com" target="_blank" rel="noopener">
        Gatsby
      </a>{" "}
      with{" "}
      <a
        href="https://www.gatsbyjs.com/docs/reference/routing/file-system-route-api/#creating-client-only-routes"
        target="_blank"
        rel="noopener"
      >
        Gatsby’s new File System Route API
      </a>
    </p>
    <p>
      <a href="https://thecatapi.com" target="_blank" rel="noopener">
        TheCatAPI
      </a>
    </p>
    <p>
      <a href="https://kanye.rest" target="_blank" rel="noopener">
        Kanye.rest
      </a>
    </p>
    <p>
      <a href="https://netlify.com" target="_blank" rel="noopener">
        Netlify
      </a>{" "}
      for hosting
    </p>
    <h2>Who?</h2>
    <p>
      <strong>An Human being</strong>
    </p>
  </Layout>
);

export default About;
